import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Banner from "../../../component/Banner";
import image5 from "../../../images/healthcare/Healthcare6.webp";
import image2 from "../../../images/healthcare/Healthcare7.webp";
import Bannerimg from "../../../images/healthcare/healthcare-banner.webp";
import image3 from "../../../images/healthcare/healthcare1.webp";
import image1 from "../../../images/healthcare/healthcare3.webp";
import image4 from "../../../images/healthcare/healthcare4.webp";
import image6 from "../../../images/healthcare/healthcare5.webp";
import image7 from "../../../images/healthcare/healthcare8.webp";
const Healthcare = () => {
  const banner = {
    title: "Healthcare",
    image: Bannerimg,
  };
  const card = [
    {
      image: image1,
      title: "Digital Health",
      description:
        "The digital revolution is not only changing the way we communicate but is also offering us more innovative ways of monitoring our health & well-being thereby giving us greater access to personal data and self-management. Digital Health as such has now emerged as one of the most far reaching trends in the healthcare industry bringing with it a broad array of technologies.",
      tagName: "Learn More",
      tagLink: "digital-health",
    },
    {
      image: image2,
      title: "Pharmacy Benefit Management",
      description:
        "Cylon Technologies amidst myriad of challenges that are driving reinvention of business operating models due to factors such as rise in drug costs, demographic changes, technological advances, shrinkage in margins and the emergence of value based care is helping healthcare providers in developing and implementing automated, streamlined processes for any part of their pharmacy benefit programs.",
      tagName: "Learn More",
      tagLink: "pharmacybenefitservices",
    },
    {
      image: image3,
      title: "Payers",
      description:
        "Payers in theory are responsible to ensure that the limited financial resources are used appropriately to create services, provide broad access to the needed healthcare services, and ensure patient safety and affordable healthcare coverage.",
      tagName: "Learn More",
      tagLink: "healthcare-payer-services",
    },
    {
      image: image4,
      title: "Providers",
      description:
        "Healthcare providers are considered as the primary channel or conduit of compassion in the healthcare sector. The majority of healthcare services are being provided through private companies and in some cases the government steps in with some safety nets.",
      tagName: "Learn More",
      tagLink: "providers",
    },
    {
      image: image5,
      title: "EHR Consulting",
      description:
        "At Cylon Technologies, we position you for EHR success from selecting to optimizing your electronic health records system that has profoundly impacted the healthcare industry through an exponential increase in the amount of data that is now available to clinicians.",
      tagName: "Learn More",
      tagLink: "ehr-consulting",
    },
    {
      image: image6,
      title: "Advance Healthcare Data Analytics",
      description:
        "Advanced Healthcare Data Analytics is the way of developing insights through the efficient use of data and application of quantitative and qualitative analysis. It helps in generating fact-based decisions for planning, management and measurement and learning purposes.",
      tagName: "Learn More",
      tagLink: "advance-healthcare-data",
    },
    {
      image: image7,
      title: "Hospital Information Systems",
      description:
        "There is an increase in the adoption of Health Information System in hospitals with the largest share by the application. As such, Cylon Technologies Hospital Information System (HIS) is a modern and innovative solution that is enabling the medical facilities across the globe in overcoming the biggest challenges in healthcare today.",
      tagName: "Learn More",
      tagLink: "hospital-information-systems",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Healthcare — Cylon Technologies – Big Data | Data Analytics | Digital
          Strategy
        </title>
      </Helmet>
      <Banner heading={banner.title} bannerimg={banner.image} />
      <section className="sec-padd page_content pb-5">
        <div className="container">
          <h2 className="heading2 text-center pb-4">Healthcare</h2>
          <p>
            Concentration on responsibility and quality results have prompted
            basic changes in the Healthcare industry. All active participants of
            this sector must re-evaluate their solution framework and structure.
            Healthcare IT solutions need services more than anyone else due to
            critical expectations of the people. One must have a feasible
            restitution in place to deliver to client requirements. We help in
            improving customer experience with reduced costs and improve
            processes.
          </p>
          <p>
            Healthcare industry can be seen combating numerous issues like
            income stagnations, competition and government control. The business
            is adjusting its plans of action to stay pertinent. Associations
            that find manageable boulevards of development and spotlight on
            clinical results, exhibit estimation of items, diminish progressing
            bolster expenses, will be the pioneers of tomorrow.
          </p>
          <div className="col-md-10 mx-auto">
            <div className="row g-md-5 g-4">
              {card.map((item, index) => (
                <div className="col-md-6" key={index}>
                  <div className="img_card">
                    <img src={item.image} alt="images" />
                    <h2 className="heading2">{item.title}</h2>
                    <p>{item.description}</p>

                    {item.tagName && item.tagLink && (
                      <div className="btn_spacet">
                        <a
                          href={item.tagLink}
                          className="btn_small outline_blue"
                        >
                          {item.tagName}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center pt-5">
              <Link
                to="/connect"
                className="btn_custom blue_btn"
                href="Inquire"
              >
                Inquire
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Healthcare;
